
import React from "react";
import HeroScreen from "./HeroSection";
import DetailsSection from "./DetailsSection";
import FeatureIcons from "./FeatureIcons";
import TestimonialSection from "./TestamonialList";
import BlogSection from "./Blogs";
import SubscribeSection from "./SubscribeSection";
import SoulmateCTASection from "./SoulmateCTASection";
import CongratulationsPopup from "./SubscribePopUp";
const Homepage = () => {
  return (
    <>
      <div className="flex items-center p-3 m-0 bg-black">
        <div className="w-full md:w-1/12 text-white text-right font-semibold announcement-text-box">
          Announcement:
        </div>
        <div className="flex flex-col items-end w-full md:w-10/12 text-white px-7 announcement-line-container" style={{fontFamily:"serif"}}>
          <marquee>
            We only approve educated person’s profiles (Minimum education Bachelors) - FREE REGISTRATIONS TILL 14 AUGUST!
          </marquee>
        </div>
      </div>

      <HeroScreen />
      <CongratulationsPopup />
      <FeatureIcons />
      <DetailsSection />
      {/* <ProfileList /> */}
      <TestimonialSection />
      <BlogSection />
      <SubscribeSection />
      <SoulmateCTASection />
    </>
  );
};


export default Homepage;
